import { Droplet } from "lucide-react";

export default function Loader() {
  return (
    <div
      data-testid="loading-screen"
      className="loader-overlay fixed inset-0 z-[100] flex flex-col items-center justify-center bg-ink grain"
    >
      <div className="relative flex flex-col items-center" style={{ animation: "fadeIn 0.8s ease both" }}>
        <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-full border border-gold/30">
          <Droplet className="h-9 w-9 fill-gold text-gold animate-floaty" strokeWidth={0} />
        </div>
        <h1 className="font-display text-4xl md:text-5xl font-semibold tracking-tight text-white">
          LUIGI <span className="text-gradient-gold">LUBE</span>
        </h1>
        <p className="mt-2 text-xs uppercase tracking-[0.4em] text-white/40">Mobile Oil Change</p>
      </div>

      <div className="mt-12 w-56 md:w-72">
        <div className="h-px w-full bg-white/10 overflow-hidden">
          <div
            className="h-full bg-gradient-to-r from-[#FFF27A] via-[#FFE000] to-[#FFD000]"
            style={{ animation: "loadbar 1s cubic-bezier(0.4,0,0.2,1) forwards" }}
          />
        </div>
        <div className="mt-3 flex justify-between text-xs tracking-widest text-white/50">
          <span>LOADING</span>
          <span data-testid="loader-progress" className="loader-count" />
        </div>
      </div>
    </div>
  );
}
